<div class="sidebar included">
	<app-sidebar-header [title]="'priceBreakdown.title.priceBreakdown' | ibeadmin | async"></app-sidebar-header>

	<div class="sidebar__body sl--scrollable" #sidebar__body>
		
		<!-- Flights -->
		<ng-container *ngIf="booked_trip.flights.length || noFlights.length">
			<div class="price-breakdown-list--title">{{ 'priceBreakdown.text.flights' | ibeadmin | async }}</div>
			
			<ng-container *ngIf="booked_trip.booking_type !== 'M' && booked_trip.flights.length">
				<ng-container *ngFor="let flight of booked_trip.flights; let i = index">
					<div class="price-breakdown-count">
						<app-svg [svg]='INDRA_printAirlineLogo(flight)' [alt]="'priceBreakdown.alt.airlineLogo' | ibeadmin | async" class="price-breakdown__airline"></app-svg>
						<div class="price-breakdown-label">
							<div class="price-breakdown-title">
								<span class="destination">
									{{ bookingSteps[i]._departure.location.city }} -
									{{ bookingSteps[i]._arrival.location.city }}
									<p class="muted">
										<a class="link" (click)="INDRA_handleDetailsClick(flight)" href="javascript:;" role="button">
											{{ 'priceBreakdown.link.details' | ibeadmin | async }}
										</a>
									</p>
								</span>
								<span class="datetime">{{ INDRA_printFlightDate(flight) | titlecase }}</span>
							</div>
							<div class="price-right" *ngIf="!bookAwardFlights">
								{{ INDRA_getFlightPrice(flight) | indracurrency }} 
							</div>
							<div *ngIf="bookAwardFlights">
								{{ INDRA_getFlightPrice(flight) | indracurrency }} 
							</div>
						</div>
					</div>
				</ng-container>
			</ng-container>
			
			<ng-container *ngIf="booked_trip.booking_type === 'M' && booked_trip.flights.length">
				<div class="multicity-content">
					<div class="multicity-details--left">
						<ng-container *ngFor="let flight of booked_trip.flights; let i = index">
							<div class="price-breakdown-count">
								<app-svg [svg]='INDRA_printAirlineLogo(flight)' 
									[alt]="'priceBreakdown.alt.airlineLogo' | ibeadmin | async"
									class="price-breakdown__airline">
								</app-svg>
								<div class="price-breakdown-label">
									<div class="price-breakdown-title">
										<div class="multicity-details">
											<span class="destination">
												{{ bookingSteps[i]._departure.location.city }} -
												{{ bookingSteps[i]._arrival.location.city }}
											</span>
											<p class="muted">
												<a class="link" (click)="INDRA_handleDetailsClick(flight)" href="javascript:;" role="button">
													{{ 'priceBreakdown.link.details' | ibeadmin | async }}
												</a>
											</p>
										</div>
										<span class="datetime">{{ INDRA_printFlightDate(flight) | titlecase }}</span>
									</div>
								</div>
							</div>
						</ng-container>
					</div>
					
					<div class="multicity-details--right">
						<div>
							<div class="price-right" *ngIf="!bookAwardFlights">
								{{ INDRA_getFlightPrice(booked_trip.flights[0]) | indracurrency }} 
							</div>
							<div *ngIf="bookAwardFlights">
								{{ INDRA_getFlightPrice(booked_trip.flights[0]) | indracurrency }} 
							</div>
						</div>
					</div>
				</div>
			</ng-container>
			
			<!-- noFlights -->
			<ng-container *ngFor="let flight of noFlights;">

				<div class="price-breakdown-count no-flight" (click)="INDRA_handleClose()">
					<app-svg class="price-breakdown__icon" svg="sprite.svg#color_icon--plane" aria-hidden="true" [alt]="'priceBreakdown.alt.planeIcon' | ibeadmin | async">
					</app-svg>
					<div class="price-breakdown-label">

						<div class="price-breakdown-title">
							<span class="destination">{{ 'priceBreakdown.text.selectYourFlight' | ibeadmin | async }}</span>
							<span class="lighter datetime">{{ 'priceBreakdown.text.reviewFlightChoice' | ibeadmin | async }}</span>
						</div>

					</div>
				</div>
			</ng-container>
			
			<div *ngIf="booked_trip.flights.length">

				<div class="price-breakdown-count price-breakdown-count--total payment-table">
					<div class="price-breakdown-label payment-table__line">
						<div class="price-breakdown-title ">
							{{ 'priceBreakdown.title.total' | ibeadmin | async }}
						</div>

						<div class="price-right bold">
							{{ INDRA_getPrice('flights') | indracurrency }} 
						</div>
					</div>
				</div>

				<div class="fare-conditions-link__wrapper" *ngIf="noFlights.length === 0">
					<a class="link" 
						(click)="INDRA_handleFareAndTaxes()"
						[attr.aria-label]="'priceBreakdown.link.fareAndTaxesInformation' | ibeadmin | async" 
						href="javascript:;" 
						role="button">
						{{ 'priceBreakdown.link.fareAndTaxesInformation' | ibeadmin | async }}
					</a>
				</div>
				
				<div class="fare-conditions-link__wrapper" *ngIf="INDRA_hasBookedTrip()">
					<a class="link" 
						(click)="INDRA_handleBack()" 
						[attr.aria-label]="'priceBreakdown.aria.resetAndChooseFlight' | ibeadmin | async" 
						href="javascript:;" 
						role="button">
						{{ 'priceBreakdown.link.changeFlights' | ibeadmin | async }}
					</a>
				</div>
			</div>
		</ng-container>
		<!-- End Flights -->
		
		<div class="divider"></div>

		<!-- Discounts -->
		<div class="price-breakdown-list" *ngIf="!isTTTFlow && isNormalBookingOrActiveTTT">
			<div class="price-breakdown-list--title">{{ 'priceBreakdown.title.discounts' | ibeadmin | async }}</div>
			<ul class="body">

				<ng-container *ngIf="!userInfo || (bookedTripDiscounts && bookedTripDiscounts.length)">
					<li class="extras-feature extras-feature__price-breakdown" *ngFor="let discount of bookedTripDiscounts">
						<div class="extras-feature__label">
							<span>{{ 'priceBreakdown.text.milesAndGo' | ibeadmin | async }} <!-- 400 miles --> </span>
						</div>
						<span class="price">
							- {{discount.value + currency | indracurrency }}
						</span>
					</li>
				</ng-container>

				<ng-container *ngIf="promocoCodesAndVoucher && promocoCodesAndVoucher.length">
					<li class="extras-feature extras-feature__price-breakdown" *ngFor="let discount of promocoCodesAndVoucher;">
						<div class="extras-feature__label">
							<span class="capitalize">
								{{ discount.type === VOUCHER_DISCOUNT ? ('priceBreakdown.text.voucher' | ibeadmin | async) : ('priceBreakdown.text.promocode' | ibeadmin | async) }}: {{ discount.code }}
								<ng-container *ngIf="discount.amountType === PERCENTAGE_TYPE_DISCOUNT">
									{{ discount.amountType === PERCENTAGE_TYPE_DISCOUNT ? '(' + discount.amount.toFixed(0) + '%)' : ''}} 
								</ng-container>
							</span> 
							
						</div>
						<span class="price">
							<ng-container *ngIf="discount.amountType === PERCENTAGE_TYPE_DISCOUNT; else fixedTypeDiscountAmount">
								- {{ booked_trip && booked_trip.flights.length > 0 && discount.actualValue > 0 ? (discount.actualValue | indracurrency: discount.currencyCode) : '' }} 
							</ng-container>
							<ng-template #fixedTypeDiscountAmount>
								- {{ discount.amount | indracurrency: discount.currencyCode }} 
							</ng-template>
						</span>
					</li>
				</ng-container>
				
				<ng-container *ngIf="weakFlightsDiscount">
					<li class="extras-feature extras-feature__price-breakdown">
						<div class="extras-feature__label">
							<span class="capitalize">{{ 'priceBreakdown.text.weakFlightDiscount' | ibeadmin | async }}</span>
						</div>
						<span class="price">
							- {{ (weakFlightsDiscount? weakFlightsDiscount.amount + currency: 0) | indracurrency }}  
						</span>
					</li>
				</ng-container>
			</ul>
		</div>

		<div class="fare-conditions-link__wrapper" *ngIf="!isTTTFlow && isNormalBookingOrActiveTTT">
			<a class="link" (click)="INDRA_handleVoucherOrPromocode()"
				[attr.aria-label]="'priceBreakdown.aria.addManagePromocode' | ibeadmin | async" 
				href="javascript:;" 
				role="button">
				<span *ngIf="promocoCodesAndVoucher && promocoCodesAndVoucher.length > 0">
					{{ 'priceBreakdown.link.manageVoucherOrPromocodes' | ibeadmin | async }}
				</span>
				<span *ngIf="!promocoCodesAndVoucher || !promocoCodesAndVoucher.length || promocoCodesAndVoucher.length === 0">
					{{ 'priceBreakdown.link.addVoucherOrPromocode' | ibeadmin | async }}
				</span>
			</a>
		</div>

		<div class="price-breakdown-count price-breakdown-count--total payment-table" 
			*ngIf="(bookedTripDiscounts && bookedTripDiscounts.length > 0) || (promocoCodesAndVoucher && promocoCodesAndVoucher.length > 0) || (weakFlightsDiscount)">
			<div class="price-breakdown-label payment-table__line">
				<div class="price-breakdown-title">
					{{ 'priceBreakdown.title.total' | ibeadmin | async }}
				</div>
				<div class="price-right bold">
					- {{ INDRA_getPrice('discounts') | indracurrency }}
				</div>
			</div>
		</div>
		<!-- End Discounts -->

		<!-- Other charges -->
		<div *ngIf="!noFlights.length && booked_trip.flights.length && !INDRA_isUserLoggedIn() && adminFee > 0">
			<div class="divider"></div>
			
			<div class="price-breakdown-list">
				<div class="price-breakdown-list--title">{{ 'priceBreakdown.title.otherCharges' | ibeadmin | async }}</div>
				<ul class="body">
					<li class="extras-feature extras-feature__price-breakdown" *ngIf="adminFee > 0">
						<div class="extras-feature__label">
							<span>{{ 'priceBreakdown.text.adminFee' | ibeadmin | async }}</span>
							<span class="lighter">
								{{ 'priceBreakdown.text.willNotBeCharged' | ibeadmin | async }}
								<a class="link" 
									[attr.aria-label]="'priceBreakdown.aria.openLoginDialog' | ibeadmin | async" 
									(click)="showLoginModal()" 
									href="javascript:;" 
									role="button">
									{{ 'priceBreakdown.link.login' | ibeadmin | async }}
								</a>
							</span>
						</div>
						<span class="price">{{ adminFee.toFixed(2) + currency | indracurrency }}</span>
					</li>
				</ul> 
				
				<div class="price-breakdown-count price-breakdown-count--total payment-table">
					<div class="price-breakdown-label payment-table__line">
						<div class="price-breakdown-title ">
							{{ 'priceBreakdown.title.total' | ibeadmin | async }}
						</div>
						<div class="price-right bold">
							{{ INDRA_getPrice('otherCharges').toFixed(2) + currency | indracurrency }}
						</div>
					</div>
				</div> 
			</div> 
		</div>
		<!-- End Other charges -->
		
		<!-- Create an account -->
		<div *ngIf="!userInfo && isNormalBookingOrActiveTTT">
			<div class="divider"></div>
			<div class="price-breakdown-account">
				<div>
					<a class="text-link" 
						href="javascript:void();" 
						(click)="showLoginModal()"
						[attr.aria-label]="'priceBreakdown.aria.openDialogToLogin' | ibeadmin | async">
						{{ 'priceBreakdown.link.loginCreateAccount' | ibeadmin | async }}
					</a>
					{{ 'priceBreakdown.text.toGetDiscount' | ibeadmin | async }}
				</div>
				<!-- <div> -->
				<!-- 	{{ 'priceBreakdown.text.dontHaveTapAccount' | ibeadmin | async }} -->
				<!-- 	<a class="link bold"  -->
				<!-- 		href="javascript:void();"  -->
				<!-- 		(click)="INDRA_handleSignUp()" -->
				<!-- 		[attr.aria-label]="'priceBreakdown.text.ariaAccountDialog' | ibeadmin | async"> -->
				<!-- 		{{ 'priceBreakdown.link.createAccountNow' | ibeadmin | async }} -->
				<!-- 	</a> -->
				<!-- 	{{ 'priceBreakdown.text.getDiscountsImmediately' | ibeadmin | async }} -->
				<!-- </div> -->
			</div>
		</div>
		<!-- End create an account -->
		
	</div>

	<div class="sidebar-flight-extras" *ngIf="!noFlights.length && booked_trip.flights.length">
		<ul class="body">
			<li class="extras-feature">
				<div class="extras-feature__label">
					<h3><strong>{{ 'priceBreakdown.title.passengersTotal' | ibeadmin | async }}</strong></h3>
					<div class="extras-feature__label--note">
						{{ 'priceBreakdown.text.feesCarrierChargesIncluded' | ibeadmin | async }}
					</div>
				</div>			
				<p class="price-total" *ngIf="!this.bookAwardFlights">
					<ng-container *ngIf="payingWithMiles">
						<strong class="price-total--original" *ngIf="isLoggedIn">{{ INDRA_printOriginalPrice() | indracurrency }}</strong>
						<div>
							<span *ngIf="isLoggedIn">
								<strong class="price-total--miles">{{ INDRA_printMiles() | indracurrency }}</strong>
								<strong> + </strong>
							</span>
							<strong>{{ INDRA_printFinalPrice() | indracurrency }}</strong>
						</div>
					</ng-container>
					<strong *ngIf="!payingWithMiles">{{ INDRA_getPrice('finalAmountWithDiscountsAndNoMilesGo') | indracurrency }} </strong>
					<!--
					<app-uplift-information-block [align]="'right'" [showDescription]=false [margin]="'0'"></app-uplift-information-block>
					-->
				</p>
				<p class="price-total" *ngIf="this.bookAwardFlights">
					<strong> {{ INDRA_getPrice('finalAmountWithDiscountsAndNoMilesGo') | indracurrency }} </strong>
				</p>	
			</li>
		</ul>
	</div>

	<div #sidebar__footer class="sidebar__footer ">
	</div>

</div>
